// Lib
import React, { ReactElement } from 'react';

// Components
import TiptapToggleListTool from './TiptapToggleListTool';

// Types
import { ToolbarToolProps } from '../../../config/toolDefinitions/toolbarToolTypes';
import { TiptapNodeType } from '../../../../../../common/tiptap/tiptapTypes';

const TiptapOrderedListTool = (props: ToolbarToolProps): ReactElement => (
    <TiptapToggleListTool {...props} listType={TiptapNodeType.orderedList} />
);

export default TiptapOrderedListTool;
